<template>
  <v-row justify="center">
    <v-dialog v-model="$store.state.openAgentCallsDialog" width="600">
      <v-card>
        <v-card-title>
          <div>المكالمات الخاصة بالطلب {{ $store.state.isCSCalls ? 'وخدمة العملاء' : 'والاستشارى' }}</div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-if="isLoading" class="d-flex justify-center py-5">
              <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
            </div>

            <div v-else-if="calls_details.length > 0">
              <v-row
                style="
                  background-color: #f8f9fa;
                  border: 1px solid #eff2f7;
                  margin-top: 20px;
                "
                class="mx-0 file-info-row d-flex align-center text-center"
              >
                <v-progress-linear color="primary" reverse></v-progress-linear>
                <v-col cols="3"> {{ $store.state.isCSCalls ? 'خدمة العملاء' : 'الاستشاري' }}</v-col>
                <v-col cols="5"> المكالمه</v-col>
                <v-col cols="4">تاريخ المكالمه</v-col>
              </v-row>

              <v-row
                v-for="item in calls_details"
                :key="item.id"
                class="mx-0 py-4 file-info-row d-flex align-center text-center"
              >
                <v-col cols="3">{{ item.agent_name }}</v-col>
                <v-col cols="5"
                  ><audio
                    controls
                    :src="item.path"
                    style="width: 100%; max-width: 200px"
                  ></audio
                ></v-col>
                <v-col cols="4">{{ item.day_date }}</v-col>
              </v-row>
            </div>

            <div v-else>
              <h2 class="mx-0 py-4 file-info-row d-flex align-center text-center">
                عفوا لا يوجد مكالمات لهذا الطلب !
              </h2>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="closeRequestCalls">
            الغاء
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { axiosInstance } from "@/axios/config";

export default {
  data() {
    return {
      calls_details: [],
      isLoading: false,
    };
  },

  methods: {
    get_calls_for_request() {
      console.log("get_calls_for_request", this.$store.state.idOfRequestCalls);
      this.calls_details = [];
      if (this.$store.state.idOfRequestCalls) {
        this.isLoading = true;
        axiosInstance
          .get(`/agent/Request/call-center/${this.$store.state.idOfRequestCalls}`, {
            params: {
              current_req_user_id: 1
              // agent_name: this.$store.state.agentNameForCalls || undefined
            }
          })
          .then((response) => {
            const agentName = this.$store.state.agentNameForCalls;
            // if (agentName) {
            //   const clean = (str) => str ? str.replace(/\s+/g, '').toLowerCase() : '';
            //   const cleanAgent = clean(agentName);
            //   this.calls_details = response.data.payload.filter(item => {
            //     if (!item.agent_name) return false;
            //     const cleanCallAgent = clean(item.agent_name);
            //     return cleanCallAgent.includes(cleanAgent) || cleanAgent.includes(cleanCallAgent);
            //   });
            // } else {
              this.calls_details = response.data.payload;
            // }
          })
          .catch((err) => {
            if (err.response && err.response.data && err.response.data.message) {
              this.showPopup("error", err.response.data.message);
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    closeRequestCalls() {
      this.$store.state.idOfRequestCalls = null;
      this.$store.state.openAgentCallsDialog = false;
      this.$store.state.agentNameForCalls = null;
      this.$store.state.isCSCalls = false;
    },
  },

  created() {
    // if (this.$store.state.openAgentCallsDialog) {
    //   this.get_calls_for_request();
    // }
  },

  watch: {
    "$store.state.openAgentCallsDialog": {
      handler(newValue) {
        if (newValue === true) {
          console.log("openAgentCallsDialog", newValue);
          this.get_calls_for_request();
        }
      },
      immediate: true,
    },
  },
};
</script>
